import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import Menu from './MenuPage'

const TutorCrud = (props) => {
    const [tutores, setTutores] = useState([]);
    const [tutor, setTutor] = useState({
        id: 0, nome: '', telefone1: '', telefone2: '', logradouro: '',
        cep: '', numero: '', bairro: '', localidade: '', uf: '',
        complemento: '', idUsuario : ''
    });

    useEffect(() => {
        carregarTutores();
    }, []);

    const carregarTutores = async () => {
        //const idUsuario = localStorage.getItem("idUsuario");
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/Tutor/getAll`, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
        setTutores(response.data);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTutor((prevTutor) => ({ ...prevTutor, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const idUsuario = localStorage.getItem("idUsuario");
        const token = localStorage.getItem("token");
        tutor.idUsuario =idUsuario;
        if (tutor.id === 0) {
           const response= await axios.post(`${API_BASE_URL}/Tutor`, tutor, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
          
           
             if(props.onSave!=null)
               props.onSave(response.data);  // devolve para a modal
        } else {
            await axios.put(`${API_BASE_URL}/Tutor`, tutor, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
        }
       
        carregarTutores();
        setTutor({ id: 0, nome: '', telefone1: '', telefone2: '', logradouro: '',
        cep: '', numero: '', bairro: '', localidade: '', uf: '',
        complemento: '', ativo: true });
    };

    const handleEdit = (tutor) => {
        setTutor(tutor);
    };

    const handleDelete = async (id) => {
         const token = localStorage.getItem("token");

        await axios.delete(`${API_BASE_URL}/Tutor/${id}`, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
        carregarTutores();
    };

    return (
        
         <div >
            {(props.onSave==null &&
            <Menu />)}
           
            <div className="container">
         
            <h2 className="mb-4">Cadastro de Tutor</h2>
            <form onSubmit={handleSubmit} className="mb-4">
                {Object.keys(tutor).map((key) => (
                    key !== 'id' && key !== 'ativo' &&
                    key !== 'idUsuario' && key !== 'idUsuarioNavigation' && (
                        <div className="mb-3" key={key}>
                            <label className="form-label">{key}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={key}
                                value={tutor[key]}
                                onChange={handleChange}
                                required={key == 'nome' }
                            />
                        </div>
                    )
                ))}
                <button type="submit" className="btn btn-success w-100">Salvar</button>
            </form>
                {(props.onSave==null && 
                <div>
            <h3>Lista de Tutores</h3>
            <ul className="list-group">
                {tutores.map((t) => (
                    <li key={t.id} className="list-group-item d-flex justify-content-between align-items-center">
                        {t.nome}
                        <div>
                            <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(t)}>Editar</button>
                            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(t.id)}>Excluir</button>
                        </div>
                    </li>
                ))}
            </ul>
             </div>)}
        </div>
          </div>
    );
};

export default TutorCrud;
